/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { useEffect, useState } from 'react'
import { servGetBalances } from '@/services/zetonium'
import {
  serviceGetNickname,
  serviceRegisterUpdateNickname
} from '@/services/users'
import { serviceGetAppLicenses } from '@/services/app-licenses'
import { useHandlerFetchErrors } from '@/hooks/fetch/useHandlerFetchErrors'

export const useAccount = ({ getAccessToken, zetoniumUserId }) => {
  const handleFetchErrors = useHandlerFetchErrors()
  const [loading, setLoading] = useState(true)
  const [nickname, setNickname] = useState()
  const [balance, setBalances] = useState()
  const [appLicenses, setAppLicenses] = useState()
  const fetchData = async () => {
    try {
      const balanceResponse = await servGetBalances({
        getAccessToken,
        searchParams: { zetoniumUserId }
      })
      const nicknameResponse = await serviceGetNickname(zetoniumUserId, getAccessToken)

      nicknameResponse.id && setNickname(nicknameResponse)
      balanceResponse && setBalances(balanceResponse)

      const appLicensesResponse = await serviceGetAppLicenses({ getAccessToken })

      setAppLicenses(appLicensesResponse)
    } catch (error) {
      handleFetchErrors(error)
    } finally {
      setLoading(false)
    }
  }
  const updateNickname = async ({
    nickname,
    setError,
    setMessage,
    setShowNotification
  }) => {
    const response = await serviceRegisterUpdateNickname(
      { nickname, userId: zetoniumUserId },
      getAccessToken
    )
    const { id, error } = response

    if (!id) {
      if (!error.message) {
        const message = 'Something is wrong please contact us'
        setError(message)
        setMessage(message)
      }

      setError(error.message)
      setShowNotification(true)

      return null
    }

    setNickname(response)
    setMessage('The nickname was updated/registered successfully')
    setShowNotification(null)
    setError(null)
  }

  useEffect(() => {
    fetchData()
  }, [])

  return {
    appLicenses,
    balance,
    loading,
    nickname,
    setNickname,
    updateNickname
  }
}
